export function GET_JOB(state) {
  return state.job;
}
